module.exports = __webpack_public_path__ + "img/check.111ecb0e.svg";